import React, { useCallback, useRef, useState } from "react";
import { Tooltip, Typography } from "@mui/material";

const isElementOverflowing = (el) => {
  if (!el) return false;
  return (
    el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
  );
};

const EllipsisTooltip = ({
  title,
  children,
  sx = {},
  component = Typography,
  placement = "top",
  arrow = true,
  ...rest
}) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const tooltipTitle =
    title !== undefined && title !== null
      ? String(title)
      : children !== undefined && children !== null
        ? String(children)
        : "";

  const checkOverflow = useCallback(() => {
    if (!tooltipTitle || tooltipTitle === "N/A") {
      setOpen(false);
      return;
    }
    setOpen(isElementOverflowing(ref.current));
  }, [tooltipTitle]);

  const Component = component;

  return (
    <Tooltip
      title={tooltipTitle}
      placement={placement}
      arrow={arrow}
      open={open}
      disableHoverListener
      disableFocusListener
      disableTouchListener
    >
      <Component
        ref={ref}
        onMouseEnter={checkOverflow}
        onMouseLeave={() => setOpen(false)}
        onFocus={checkOverflow}
        onBlur={() => setOpen(false)}
        sx={sx}
        {...rest}
      >
        {children}
      </Component>
    </Tooltip>
  );
};

export default EllipsisTooltip;
